"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsageType = void 0;
var UsageType;
(function (UsageType) {
    UsageType["ARTIKEL_1_LID_2_OF_LID_3"] = "ART";
    UsageType["GROOTVERBRUIK"] = "GVB";
    UsageType["KLEINVERBRUIK"] = "KVB";
})(UsageType = exports.UsageType || (exports.UsageType = {}));
